export enum SURVEY_LAUNCH_METHOD{
    EMAIL = 0,
    PORTAL = 1,
    WEB = 2,
    SOCIAL = 3,
    SITE = 4

}